import { useEffect, useState } from 'react';
import { ACCESS_LEVELS } from '@common/constants';
import useGetAccount from './useGetAccount';

const useCreateAccountCompanyValidation = () => {
  const [canCreate, setCanCreate] = useState(false);
  const { accountData } = useGetAccount();

  useEffect(() => {
    if (!accountData) return;

    const isAccountAdmin = accountData.accessLevels?.accountAdmin ?? false;
    const isProjectAdmin = accountData.accessLevels?.projectAdmin ?? false;
    const hasProjectAdminAccessLevel =
      !!accountData.createCompanyAccessLevels?.includes(
        ACCESS_LEVELS.PROJECT_ADMIN
      );
    const isNotAdmin = !isProjectAdmin && !isAccountAdmin;
    const isNotEnabled =
      !isAccountAdmin && isProjectAdmin && !hasProjectAdminAccessLevel;

    if (isNotAdmin || isNotEnabled) {
      setCanCreate(false);
    } else {
      setCanCreate(true);
    }
  }, [accountData]);

  return canCreate;
};

export default useCreateAccountCompanyValidation;
